import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/Iconify';
// material
import {
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  Card,
  Typography,
  Modal,
  Box,
  CircularProgress,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableContainer,
  TableBody,
  Button
} from '@mui/material';
import { LoadingButton, TabContext } from '@mui/lab';
// component
import { api } from 'src/Api';
import Alert from '@mui/material/Alert';
import { Encryption } from 'src/functions/function';

// ----------------------------------------------------------------------

export default function LoadsPlans() {
  const navigate = useNavigate();

  const [rolesData, setRolesData] = useState([]);
  const [billingPlans, setBillingPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(4);

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    getBillingPlans();
  }, [selectedPlanId]);

  const getBillingPlans = () => {
    setLoading(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`${api.get_packages}?role_id=${selectedPlanId}`, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          return response.json().then((error) => {});
        }
      })
      .then((result) => {
        setBillingPlans(result.data);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const getRoles = () => {
    setLoading(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(api.getRoleSignUp, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          return response.json().then((error) => {});
        }
      })
      .then((result) => {
        setRolesData(result.data);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSelectPlan = (id) => {
    navigate('/signup', { state: { role: id } });
  };

  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // Switch the tab based on user selection
  };

  return (
    <Box
      sx={{
        p: 4,
        paddingTop: '10%',
        width: '100%',
        minHeight: '100%',
        background: '#010F58'
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} ml={0.7}>
        <Button
          variant="contained"
          style={{ backgroundColor: '#fff' }}
          onClick={() => navigate('/login', { replace: true })}
          startIcon={<Iconify icon="lets-icons:back" style={{ fontSize: 19 }} />}
          sx={{ alignSelf: 'end', fontSize: 12, color: '#010F58' }}
        >
          Back
        </Button>
      </Stack>
      <TabContext value={selectedTab.toString()}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="#0046E0"
          textColor="primary"
          sx={{
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 0
          }}
        >
          {rolesData.map((val) => {
            return (
              <Tab
                sx={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  width: '23%',
                  marginRight: '2%',
                  marginLeft: '5px',
                  borderTopRightRadius: '20px',
                  borderTopLeftRadius: '20px',
                  backgroundColor: selectedPlanId == val.id ? '#192129' : '#0046E0',
                  height: '60px',
                  color: '#ffffff'
                }}
                label={val.role_name}
                onClick={() => setSelectedPlanId(val.id)}
              />
            );
          })}
        </Tabs>
      </TabContext>
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: '99.2%',
            marginLeft: '5px',
            backgroundColor: '#192129'
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '99.2%',
                height: '100vh',
                marginLeft: '5px'
              }}
            >
              <CircularProgress sx={{ color: '#0046E0' }} />
            </Box>
          ) : (
            <>
              {billingPlans.map((plan, index) => (
                // <Card
                //   key={index}
                //   sx={{
                //     p: 0,
                //     width: 220,
                //     height: 360,
                //     borderRadius: 3,
                //     overflow: 'visible',
                //     boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                //     background:
                //       index == 0
                //         ? 'linear-gradient(135deg, #7151A5, #C4B5FD)'
                //         : index == 1
                //         ? 'linear-gradient(135deg, #E58D00, #FCD34D)'
                //         : index == 2
                //         ? 'linear-gradient(135deg, #388855, #69c289)'
                //         : 'linear-gradient(135deg, #a30088, #ff8ae5)',
                //     zIndex: 0,
                //     marginBottom: { xs: 5, md: 5, lg: 0 }
                //   }}
                // >
                //   <Box
                //     sx={{
                //       height: 310,
                //       background: 'white',
                //       width: 220,
                //       borderRadius: 3,
                //       position: 'absolute',
                //       top: 25,
                //       left: 25,
                //       boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                //       zIndex: 1000
                //     }}
                //   >
                //     <Box sx={{ pb: 2, pl: 2, pr: 2 }}>
                //       <Box
                //         sx={{
                //           display: 'flex',
                //           justifyContent: 'center'
                //         }}
                //       >
                //         <Box
                //           sx={{
                //             position: 'relative',
                //             top: -50,
                //             background:
                //               index == 0
                //                 ? 'linear-gradient(135deg, #7151A5, #C4B5FD)'
                //                 : index == 1
                //                 ? 'linear-gradient(135deg, #E58D00, #FCD34D)'
                //                 : index == 2
                //                 ? 'linear-gradient(135deg, #388855, #69c289)'
                //                 : 'linear-gradient(135deg, #a30088, #ff8ae5)',
                //             padding: '5px', // Instead of border width
                //             borderRadius: '50%'
                //           }}
                //         >
                //           <Box
                //             sx={{
                //               borderRadius: '50%',
                //               backgroundColor: '#333',
                //               width: 120,
                //               height: 120,
                //               display: 'flex',
                //               flexDirection: 'column',
                //               alignItems: 'center',
                //               justifyContent: 'center',
                //               color: 'white',
                //               boxShadow: `0 0 0 6px white, 0 0 0 8px ${
                //                 index == 0
                //                   ? 'linear-gradient(135deg, #7151A5, #C4B5FD)'
                //                   : index == 1
                //                   ? 'linear-gradient(135deg, #E58D00, #FCD34D)'
                //                   : index == 2
                //                   ? 'linear-gradient(135deg, #388855, #69c289)'
                //                   : 'linear-gradient(135deg, #a30088, #ff8ae5)'
                //               }`
                //             }}
                //           >
                //             <Typography sx={{ mb: 0.3, fontSize: 16, fontWeight: 'bold' }}>
                //               ${plan?.amount}
                //             </Typography>
                //             <Typography sx={{ opacity: 0.8, mb: 0.6, fontSize: 10 }}>
                //               PRICE CREDIT
                //             </Typography>
                //             <LoadingButton
                //               onClick={() => handleSelectPlan(plan?.role?.id)}
                //               style={{
                //                 background:
                //                   index == 0
                //                     ? 'linear-gradient(135deg, #7151A5, #C4B5FD)'
                //                     : index == 1
                //                     ? 'linear-gradient(135deg, #E58D00, #FCD34D)'
                //                     : index == 2
                //                     ? 'linear-gradient(135deg, #388855, #69c289)'
                //                     : 'linear-gradient(135deg, #a30088, #ff8ae5)'
                //               }}
                //               variant="contained"
                //               sx={{ fontSize: 9, letterSpacing: 0.5 }}
                //             >
                //               Subscribe
                //             </LoadingButton>
                //           </Box>
                //         </Box>
                //       </Box>
                //       <Typography
                //         variant="h6"
                //         sx={{
                //           mt: -4,
                //           mb: 1,
                //           fontWeight: 'bold',
                //           color: '#333'
                //         }}
                //       >
                //         {plan?.role?.role_name}
                //       </Typography>
                //       <Box
                //         sx={{
                //           mb: 3,
                //           height: 150,
                //           overflowY: 'auto',
                //           overflowX: 'hidden',
                //           '&::-webkit-scrollbar': {
                //             width: '6px'
                //           },
                //           '&::-webkit-scrollbar-track': {
                //             background: '#f1f1f1',
                //             borderRadius: '10px'
                //           },
                //           '&::-webkit-scrollbar-thumb': {
                //             background: '#888',
                //             borderRadius: '10px',
                //             '&:hover': {
                //               background: '#555'
                //             }
                //           }
                //         }}
                //       >
                //         {plan?.package_details?.map((feature, idx) => (
                //           <Box
                //             key={idx}
                //             sx={{
                //               display: 'flex',
                //               alignItems: 'center',
                //               mb: 0.5,
                //               color: '#666'
                //             }}
                //           >
                //             <Iconify
                //               icon="ic:round-check"
                //               sx={{
                //                 mr: 1.5,
                //                 color:
                //                   index == 0
                //                     ? '#7151A5'
                //                     : index == 1
                //                     ? '#E58D00'
                //                     : index == 2
                //                     ? '#388855'
                //                     : '#a30088',
                //                 fontSize: 13
                //               }}
                //             />
                //             <Typography sx={{ fontSize: 10 }}>{feature.description}</Typography>
                //           </Box>
                //         ))}
                //       </Box>
                //     </Box>
                //   </Box>
                // </Card>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 4
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '250px',
                      height: '150px'
                    }}
                  >
                    <Typography sx={{ color: 'white', fontSize: 30, fontWeight: 'bold' }}>
                      {plan?.duration}
                    </Typography>
                    <Typography
                      sx={{ color: 'white', fontSize: 30, fontWeight: 'bold', display: 'flex' }}
                    >
                      <p
                        style={{
                          fontWeight: '500',
                          fontSize: 15,
                          marginRight: '3px',
                          marginTop: 5
                        }}
                      >
                        $
                      </p>
                      {plan?.amount}
                    </Typography>
                    <Typography sx={{ color: 'white', fontSize: 13, fontWeight: '500' }}>
                      7 days
                    </Typography>
                    <Typography sx={{ color: 'white', fontSize: 13, fontWeight: '500' }}>
                      Free Trial
                    </Typography>
                  </Box>
                  <LoadingButton
                    variant="contained"
                    sx={{
                      mt: 4,
                      backgroundColor: '#0046E0',
                      borderRadius: '100px',
                      height: '25px',
                      fontSize: '9px',
                      letterSpacing: '0.5px',
                      width: '100px',
                      textTransform: 'uppercase'
                    }}
                    onClick={() => handleSelectPlan(plan?.role?.id)}
                  >
                    Subscribe
                  </LoadingButton>
                </Box>
              ))}
            </>
          )}
        </Box>

        {!loading && (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              width: '99.2%',
              marginLeft: '5px',
              backgroundColor: '#192129',
              paddingTop: 4
            }}
          >
            <Typography
              sx={{
                color: 'white',
                fontSize: 20,
                fontWeight: 'bold',
                backgroundColor: '#192129',
                padding: '0px 0px 0px 17px'
              }}
            >
              {selectedTab == 0
                ? 'Truck Driver '
                : selectedTab == 1
                ? 'Shiper '
                : selectedTab == 2
                ? 'Broker '
                : 'Carrier '}
              Loads Board Plans:
            </Typography>

            <TableContainer
              component={Paper}
              sx={{
                backgroundColor: '#192129',
                borderRadius: 0,
                mb: 2
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {billingPlans[0]?.package_details?.map((val, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 0 ? 'transparent' : '#2E3A45',
                        '& td': {
                          borderTop: 'none',
                          borderBottom: 'none',
                          borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
                          borderRight: '1px solid rgba(255, 255, 255, 0.1)',
                          '&:first-of-type': {
                            borderLeft: 'none'
                          },
                          '&:last-of-type': {
                            borderRight: 'none'
                          }
                        }
                      }}
                    >
                      <TableCell align="left">
                        <Typography style={{ fontSize: 15, fontWeight: 'bold', color: '#fff' }}>
                          {val.description}
                        </Typography>
                      </TableCell>
                      <TableCell align="center" sx={{ width: '250px' }}>
                        <Iconify icon={'mdi:check-bold'} sx={{ color: '#0046E0' }} />
                      </TableCell>
                      <TableCell align="center" sx={{ width: '250px' }}>
                        <Iconify icon={'mdi:check-bold'} sx={{ color: '#0046E0' }} />
                      </TableCell>
                      <TableCell align="center" sx={{ width: '250px' }}>
                        <Iconify icon={'mdi:check-bold'} sx={{ color: '#0046E0' }} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </>
    </Box>
  );
}
